// Tracks Shopify analytics consent (relayed in by locator_init.js) outside
// React, so modules that sit above or outside UserContext — ErrorBoundary,
// auth.service.js, Utils.js — can read the analytics mode without needing a
// context to be mounted yet.
//
// An absent value means no consent enforcement is active on the host page, so
// it counts as granted. Any other value that isn't "yes" — including a visitor
// who hasn't answered the banner — counts as denied, so measurement continues
// in anonymous mode rather than being lost.
export const normalizeConsentValue = (value) => {
  if (value === null || value === undefined) return "yes";
  return value === "yes" ? "yes" : "no";
};

let currentAnalyticsConsent = normalizeConsentValue(
  new URLSearchParams(window.location.search).get("consentAnalytics")
);

// Per-org override (from storeLocatorConfig, set once fetched — see Home.js
// loginRequest). Starts undefined (unresolved, not false) so denied consent
// stays fully blocked until we actually know the org's preference — only an
// explicit `false` from setForceBlockTrackingOnDeny allows anonymous mode (no
// cookies, no persistent identifiers, no IP). If config never resolves (fetch
// fails), this stays unresolved forever and tracking stays blocked — fail
// closed, not fail open.
let forceBlockTrackingOnDeny;

window.addEventListener("message", (event) => {
  if (event.data?.action !== "consent-update") return;
  currentAnalyticsConsent = normalizeConsentValue(event.data.analytics);
});

export function setForceBlockTrackingOnDeny(value) {
  forceBlockTrackingOnDeny = !!value;
}

// "granted": full tracking. "anonymous": denied consent, org allows anonymous
// mode. "blocked": nothing is measured. GTM keys its tag blocking and tracker
// choice off this value, so it is the single place the rules live.
export function getAnalyticsMode() {
  if (currentAnalyticsConsent === "yes") return "granted";
  if (currentAnalyticsConsent === "no" && forceBlockTrackingOnDeny === false) {
    return "anonymous";
  }
  return "blocked";
}
